import { z } from "zod";

export const createAdvancedFlow = {
  input: z.object({ newFlow: z.any(), setIndex: z.boolean() }), // TODO @mlewis850 fill this out with actual types
  output: z.object({ id: z.string() }),
};
